// Единый deepLink для create-from-chat artifact_card (server persist + client CTA).

import type { TutorCreateFromChatArtifact } from "./schemas.js";

/**
 * Relative app path для открытия готового артефакта.
 * Канон для `artifact_card.deepLink` и UI Open.
 */
export function deepLinkForCreateFromChatArtifact(
	artifact: TutorCreateFromChatArtifact,
	jobRef: string,
): string {
	switch (artifact) {
		case "notes":
			return `/notes/${jobRef}`;
		case "flashcards":
			return `/flashcards/study/${jobRef}`;
		case "quiz":
			return `/tests/take/${jobRef}`;
		case "glossary":
			return "/glossary";
	}
}
